import React, { PureComponent } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";

export class Option extends PureComponent {
  static propTypes = {
    innerProps: PropTypes.object,
    isFocused: PropTypes.bool,
    isKeyUsed: PropTypes.bool,
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    showValueInLabel: PropTypes.bool,
    value: PropTypes.string
  };

  static defaultProps = {
    innerProps: {},
    isFocused: false,
    isKeyUsed: false,
    isSelected: false,
    label: "",
    showValueInLabel: false,
    value: ""
  };

  handleChange = () => {};

  render() {
    const label = this.props.showValueInLabel ? `${this.props.label} (${this.props.value})` : this.props.label;

    return (
      <div
        role="presentation"
        className={classNames("checkbox__container", this.props.isFocused && this.props.isKeyUsed && "--focused")}
        onClick={this.props.innerProps.onClick}>
        <input
          className={classNames("checkbox", this.props.isSelected && "checkbox__checked")}
          type="checkbox"
          checked={this.props.isSelected}
          onChange={this.handleChange}
        />
        <span className="checkbox__label">{label}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/Option.js